import baseService from './baseService';

class FollowService extends baseService {
  static isFollow(id, type) {
    return this.axiosMethod('get', 'paimai', 'paimai_isFollow', {
      id,
      type
    })
  }
  static follow(id, type) {
    return this.axiosMethod('get', 'paimai', 'follow', {
      id,
      type
    })
  }
  static unFollow(id, type) {
    return this.axiosMethod('get', 'paimai', 'unFollow', {
      id,
      type
    })
  }
}

export default FollowService